import React, { useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getPreviewTheme,
  subscribePreviewTheme,
  isLightPreviewTheme,
  type PreviewThemeId,
} from '../preview/theme/previewTheme';

// 푸터는 .app-root 밖(앱 셸)에 렌더되어 preview 의 CSS 변수를 상속받지
// 못한다 — 테마 스토어를 직접 구독해 색을 맞춘다.
// 값은 각 테마의 --bg-0 / --text-3 와 맞춘다.
type FooterPalette = { bg: string; border: string; text: string };

const PALETTE: Partial<Record<PreviewThemeId, FooterPalette>> & { default: FooterPalette } = {
  default: { bg: '#0A0A0A', border: 'rgba(255,255,255,0.08)', text: '#6B7280' },
  light: { bg: '#DFE5EE', border: 'rgba(15,23,42,0.10)', text: '#64748B' },
  vivid: { bg: '#0E0B12', border: 'rgba(255,255,255,0.08)', text: '#8A8195' },
  'vivid-light': { bg: '#F0E4EC', border: 'rgba(30,20,32,0.10)', text: '#7B6B78' },
  heavenly: { bg: '#071322', border: 'rgba(255,255,255,0.08)', text: '#7794AE' },
  'heavenly-light': { bg: '#D6EAF6', border: 'rgba(16,34,51,0.10)', text: '#5E7B93' },
  vgc: { bg: '#E3C49B', border: 'rgba(43,26,14,0.12)', text: '#8A7360' },
};

// 테마가 추가될 때마다 이 맵을 갱신하는 걸 잊으면 라이트 테마 화면 아래에
// 검은 띠(default 팔레트)가 남는다 — 실제로 vgc 에서 그랬다.
// 등록 전이라도 최소한 명암 방향은 맞도록 라이트 패밀리는 라이트로 떨어뜨린다.
function paletteFor(theme: PreviewThemeId): FooterPalette {
  return PALETTE[theme] ?? (isLightPreviewTheme(theme) ? PALETTE.light! : PALETTE.default);
}

const Footer: React.FC = () => {
  const location = useLocation();
  const theme = useSyncExternalStore(subscribePreviewTheme, getPreviewTheme);

  if (location.pathname.includes('/export')) {
    return null;
  }

  const palette = paletteFor(theme);

  return (
    <footer
      className="hidden md:block py-4 mt-auto"
      style={{ background: palette.bg, borderTop: `1px solid ${palette.border}` }}
    >
      <div className="mx-auto px-4 max-w-[1400px]">
        <p className="text-center text-xs" style={{ color: palette.text }}>
          본 서비스의 곡 정보, 이미지 등 게임 관련 데이터의 권리는 KONAMI Arcade Games 및 각 소유권자에게 있습니다.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
